import {PLATFORMS} from '../../../common/constants/constants';

const BOX_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const PRODUCT_IMAGE_SIZES = {
  [PLATFORMS.DESKTOP]: {
    [BOX_SIZES.SMALL]: {
      width: 244,
      height: 224,
    },
    [BOX_SIZES.MEDIUM]: {
      width: 347,
      height: 224,
    },
    [BOX_SIZES.LARGE]: {
      width: 251,
      height: 251,
    },
  },
  [PLATFORMS.MOBILE]: {
    [BOX_SIZES.SMALL]: {
      width: 130,
      height: 130,
    },
    [BOX_SIZES.MEDIUM]: {
      width: 130,
      height: 130,
    },
    [BOX_SIZES.LARGE]: {
      width: 130,
      height: 130,
    },
  }
};

export {
  BOX_SIZES,
  PRODUCT_IMAGE_SIZES,
}



// WEBPACK FOOTER //
// ./src/view/productSummaryBoxes/discountsHourlyProductSummaryBox/discountsHourlyProductSummaryBoxConstants.js